import React, { useEffect, useState } from "react";
import PreviousIcon from "./PreviousIcon";
import NextIcon from "./NextIcon";

interface PaginationProps {
  pageLimit: number | undefined;
  totalRows: number;
  onPageChange: Function;
  maxPageNumsInView?: number;
}

function Pagination({
  pageLimit = 1,
  totalRows,
  onPageChange,
  maxPageNumsInView=10
}: PaginationProps) {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageList, setPageList] = useState<number[]>([]);

  const pageNumbers = [];
  const totalPages = Math.ceil(totalRows / pageLimit);

  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const handleLeftButtonClick = () => {
    const newList = [...pageList];
    for(let i=1; i<=maxPageNumsInView; i++){
      if(newList[0] - 1 >= 1){
        newList.unshift(newList[0]-1);
        newList.pop();
      }
    }
    setPageList([...newList])
  };

  const handleRightButtonClick = () => {
    const newList = [...pageList];
    for(let i=1; i<=maxPageNumsInView; i++){
      if(newList[newList.length -1] + 1 <= totalPages){
        newList.shift();
        newList.push(newList[newList.length-1]+1);
      }
    }
    setPageList([...newList])
  };

  const isPrevDisabled =  pageList[0] === 1;
  const isNextDisabled = pageList[pageList.length-1] === totalPages;

  useEffect(()=>{
    const list=[];
    for(let i=1; i<=maxPageNumsInView; i++){
      if(i<=totalPages){
        list.push(i);
      }
    }
    setPageList([...list]);
    setCurrentPage(1);
  },[maxPageNumsInView, totalRows])

  return (
    <div style={{ display: "flex", margin: "8px 0" }}>
      <button
        className={`FounditUI_pagination_arrow ${
          isPrevDisabled ? "FounditUI_pagination_disabled" : ""
        }`}
        onClick={handleLeftButtonClick}
        disabled={isPrevDisabled}
      >
        <PreviousIcon />
      </button>

      <div>
        <ul className="FounditUI_pagination_container">
          {pageList?.map((page) => (
            <li
              className={`FounditUI_pagination_list_item ${
                page === currentPage ? "FounditUI_pagination_active" : ""
              }`}
              key={page}
              onClick={() => {
                if (String(currentPage) !== String(page)) {
                  // onPageChange func should not trigger on same page button click
                  onPageChange(page);
                  setCurrentPage(page);
                }
              }}
            >
              {page}
            </li>
          ))}
        </ul>
      </div>

      <button
        className={`FounditUI_pagination_arrow ${
          isNextDisabled ? "FounditUI_pagination_disabled" : ""
        }`}
        onClick={handleRightButtonClick}
        disabled={isNextDisabled}
      >
        <NextIcon />
      </button>
    </div>
  );
}

export default Pagination;
